(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    var TEXT = [
      '.pagehead__inner',
      '.feature__inner',
      '.collections__head',
      '.workshops__intro',
      '.storyvideo__inner',
      '.enquiry__aside',
      '.enquiry__formwrap',
      '.yfooter__brand'
    ];
    var MEDIA = ['.pagehead__media', '.feature__media', '.storyvideo__media'];
    // Groups that genuinely read as a list, so a stagger is honest.
    var LISTS = ['.collections__grid > .ctile', '.workshops__grid > .wtile', '.yfooter__column'];

    var STAGGER = 90;
    var MAX_STEPS = 4;
    var observer = null;

    function mark(el, variant) {
      if (!el || el.classList.contains('rv')) return;
      el.classList.add('rv', 'rv--' + variant);
      if (observer) observer.observe(el);
    }

    function init() {
      if (!('IntersectionObserver' in window)) return;

      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.01 }
      );

      TEXT.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          mark(el, 'text');
        });
      });

      MEDIA.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          mark(el, 'media');
        });
      });

      LISTS.forEach(function (sel) {
        var items = document.querySelectorAll(sel);
        items.forEach(function (el, i) {
          var step = Math.min(i, MAX_STEPS);
          el.style.setProperty('--rv-delay', step * STAGGER + 'ms');
          mark(el, 'media');
        });
      });

      failsafe();
    }

    // These elements start invisible, so if the observer never delivers we
    // would be hiding the page. If anything is sitting in the viewport
    // un-revealed shortly after load, show everything.
    function failsafe() {
      setTimeout(function () {
        var stuck = false;
        document.querySelectorAll('.rv:not(.is-in)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) stuck = true;
        });
        if (!stuck) return;
        document.querySelectorAll('.rv').forEach(function (el) {
          el.classList.add('is-in');
        });
      }, 2000);
    }

    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
    // Re-scan when the theme editor or `theme dev` swaps a section in.
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
